import type { SVGProps } from "react";

export type IconName =
  | "alert"
  | "arrow-right"
  | "brain"
  | "center"
  | "chevron"
  | "close"
  | "decision"
  | "eye"
  | "info"
  | "label"
  | "list"
  | "menu"
  | "minus"
  | "network"
  | "note"
  | "plus"
  | "process"
  | "rotate"
  | "search"
  | "source"
  | "topic";

interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName;
  size?: number;
}

function IconPath({ name }: { name: IconName }) {
  switch (name) {
    case "alert":
      return (
        <>
          <path d="M10.3 3.5 2.8 17a2 2 0 0 0 1.75 3h14.9a2 2 0 0 0 1.75-3L13.7 3.5a1.95 1.95 0 0 0-3.4 0Z" />
          <path d="M12 8v4.5" />
          <path d="M12 16.5h.01" />
        </>
      );
    case "arrow-right":
      return (
        <>
          <path d="M5 12h14" />
          <path d="m14 7 5 5-5 5" />
        </>
      );
    case "brain":
      return (
        <>
          <path d="M9.5 4.4A3.2 3.2 0 0 0 4.7 7a3.1 3.1 0 0 0 .1 6 3.3 3.3 0 0 0 4.7 4.7" />
          <path d="M14.5 4.4A3.2 3.2 0 0 1 19.3 7a3.1 3.1 0 0 1-.1 6 3.3 3.3 0 0 1-4.7 4.7" />
          <path d="M9.5 4.5v15M14.5 4.5v15M7.3 9.2c.8.1 1.6.5 2.2 1.2M16.7 9.2c-.8.1-1.6.5-2.2 1.2M7.2 15.1c.9-.1 1.7-.5 2.3-1.2M16.8 15.1c-.9-.1-1.7-.5-2.3-1.2" />
        </>
      );
    case "center":
      return (
        <>
          <circle cx="12" cy="12" r="3" />
          <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
        </>
      );
    case "chevron":
      return <path d="m8 14 4-4 4 4" />;
    case "close":
      return (
        <>
          <path d="m6 6 12 12" />
          <path d="m18 6-12 12" />
        </>
      );
    case "decision":
      return (
        <>
          <circle cx="12" cy="5" r="2" />
          <circle cx="6" cy="18" r="2" />
          <circle cx="18" cy="18" r="2" />
          <path d="M12 7v4M12 11l-6 5M12 11l6 5" />
        </>
      );
    case "eye":
      return (
        <>
          <path d="M2.5 12s3.4-6 9.5-6 9.5 6 9.5 6-3.4 6-9.5 6-9.5-6-9.5-6Z" />
          <circle cx="12" cy="12" r="2.5" />
        </>
      );
    case "info":
      return (
        <>
          <circle cx="12" cy="12" r="9" />
          <path d="M12 11v5" />
          <path d="M12 8h.01" />
        </>
      );
    case "label":
      return (
        <>
          <path d="M20 13 13 20l-9-9V4h7l9 9Z" />
          <circle cx="8.5" cy="8.5" r="1" />
        </>
      );
    case "list":
      return (
        <>
          <path d="M9 6h11M9 12h11M9 18h11" />
          <circle cx="4" cy="6" r=".7" fill="currentColor" stroke="none" />
          <circle cx="4" cy="12" r=".7" fill="currentColor" stroke="none" />
          <circle cx="4" cy="18" r=".7" fill="currentColor" stroke="none" />
        </>
      );
    case "menu":
      return (
        <>
          <path d="M5 7h14M5 12h14M5 17h14" />
        </>
      );
    case "minus":
      return <path d="M5 12h14" />;
    case "network":
      return (
        <>
          <circle cx="12" cy="5" r="2" />
          <circle cx="5" cy="17" r="2" />
          <circle cx="19" cy="17" r="2" />
          <path d="m10.9 6.8-4.8 8.4M13.1 6.8l4.8 8.4M7 17h10" />
        </>
      );
    case "note":
      return (
        <>
          <path d="M6 3h9l3 3v15H6V3Z" />
          <path d="M14 3v4h4M9 11h6M9 15h6" />
        </>
      );
    case "plus":
      return <path d="M12 5v14M5 12h14" />;
    case "process":
      return (
        <>
          <circle cx="6" cy="6" r="2" />
          <circle cx="18" cy="18" r="2" />
          <path d="M8 6h6a4 4 0 0 1 4 4v1M16 18h-6a4 4 0 0 1-4-4v-1" />
          <path d="m16 9 2 2 2-2M8 15l-2-2-2 2" />
        </>
      );
    case "rotate":
      return (
        <>
          <path d="M20 7v5h-5" />
          <path d="M19 12a7 7 0 1 1-1.4-4.2L20 10" />
        </>
      );
    case "search":
      return (
        <>
          <circle cx="11" cy="11" r="7" />
          <path d="m16.2 16.2 4.3 4.3" />
        </>
      );
    case "source":
      return (
        <>
          <path d="M8.5 15.5 15.5 8.5" />
          <path d="M14 6h4v4" />
          <path d="M18 14v5H5V6h5" />
        </>
      );
    case "topic":
      return (
        <>
          <rect x="4" y="4" width="6" height="6" rx="1" />
          <rect x="14" y="4" width="6" height="6" rx="1" />
          <rect x="4" y="14" width="6" height="6" rx="1" />
          <rect x="14" y="14" width="6" height="6" rx="1" />
        </>
      );
  }
}

export function Icon({ name, size = 18, className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      height={size}
      viewBox="0 0 24 24"
      width={size}
      {...props}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.6"
    >
      <IconPath name={name} />
    </svg>
  );
}
